import registerTodoTitleRenderer from './todo-title';

const renderers = {
  todoTitle: registerTodoTitleRenderer,
};

export default function registerRenderers(Handsontable) {
  Object.keys(renderers).forEach((name) => {
    const renderer = renderers[name](Handsontable);
    Handsontable.renderers.registerRenderer(name, renderer);
  });
}
